import Controller from '@ember/controller';
import { task } from "ember-concurrency";
import { inject as service } from '@ember/service';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';

export default class AdminCompanyCreateController extends Controller {
  @service('state-managers/application') applicationStateManager;
  @service('commands/company-commands') companyCommandService;
  @service('commands/company-group-commands') companyGroupsCommandService;

  @service shData;

  @task
  *createCompanyTask(
    name,
    description,
    location,
    domainName,
    companyGroup,
    sharesRates
  ) {
    const company = yield this.companyCommandService.createNewCompany({
      name,
      description,
      opt_locationId: location?.id,
      opt_domain: domainName,
      opt_companyGroupId: companyGroup?.id,
      opt_isSharingRates: sharesRates,
    });

    this.applicationStateManager.addToast('Company Created');
    window.location.assign(`/company/${company.slug}?section=account`);
  }

  @task({ drop: true })
  *loadCompanyGroupsTask() {
    try {
      const response = yield this.companyGroupsCommandService.loadAllCompanyGroups();

      this.shData.pushResponseToStore(response);

      return this.shData.getModelArrayFromResponse(response, 'companyGroup');
    } catch (e) {
      handleErrorResponseWithModal(this, e, 'Failed to load company groups');
    }
  }
}
